import { useEffect, useState } from 'react';
import { consumeNavigationIntent, NavigationIntent } from '../utils/navigationIntent';
import { useLocation } from 'react-router-dom';

export function useNavigationIntent() {
    const location = useLocation();
    const [intent, setIntent] = useState<NavigationIntent | null>(null);

    useEffect(() => {
        const pendingIntent = consumeNavigationIntent();
        if (pendingIntent) {
            const currentPath = location.pathname;
            const targetPath = pendingIntent.targetPath;

            if (!targetPath || currentPath === targetPath || (targetPath === '/' && currentPath === '/hub')) {
                setIntent(pendingIntent);
            }
        }
    }, [location.pathname]);

    return intent;
}
